module.exports = __webpack_public_path__ + "static/meninas-fazendo-atividades-bea40a45b1346923f0eb7b97f4ae4d4d.png";